import { dark, darkColors, light } from '../constants';
export const themeColors = (color)=>{
    if (darkColors.includes(color)) {
        return dark;
    }
    return light;
};

//# sourceMappingURL=theme.js.map